// extracted by mini-css-extract-plugin
export default {"loadingContainer":"oXf1O__loadingContainer","icon":"oi59V__icon","msg":"Bflku__msg","loader":"COFmk__loader","spin":"o1srs__spin"};